import { useSelector } from 'react-redux';
import Router from 'utils/routing';
import Header from 'modules/common/components/Header';
import Sidebar from 'modules/common/components/Sidebar';
import GlobalStyles from 'utils/theme/globalStyles';
import hideElements from 'configs/hideElements';

import { MainWrapper, SidebarWrapper, ContentWrapper, PageWrapper } from './MainContainer.style';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const MainContainer = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const context = useSelector(state => state.common.context);
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  const shouldShowHeader =
    context && hideElements.contextsThatHideHeader.includes(context) === false;
  const shouldShowSidebar =
    context && hideElements.contextsThatHideSidebar.includes(context) === false;

  return (
    <>
      <GlobalStyles />
      <MainWrapper>
        {shouldShowSidebar && (
          <SidebarWrapper>
            <Sidebar />
          </SidebarWrapper>
        )}
        <ContentWrapper>
          {shouldShowHeader && <Header />}
          <PageWrapper>
            <Router />
          </PageWrapper>
        </ContentWrapper>
      </MainWrapper>
    </>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

MainContainer.propTypes = {};

MainContainer.defaultProps = {};

export default MainContainer;
